import {
	Button,
	Dropdown,
	Spin,
	Modal,
	Table,
	Card,
	Flex,
	Switch,
} from "antd";
import { useState } from "react";
import {
	CheckOutlined,
	CloseOutlined,
	DeleteFilled,
	DownOutlined,
	EditFilled,
	VerticalAlignMiddleOutlined,
} from "@ant-design/icons";
import Toast from "../../helpers/Toast";
import { catchError } from "../../services/DaoService";
import { EtapeModeleService } from "../../services/EtapeModeleService";
import EtapeModeleEditForm from "./EtapeModeleEditForm";
import PropTypes from "prop-types";
import ReorganisableList from "../utils/ReorganisableList";

const EtapeModeleList = ({ etapeModeles, setEtapeModeles }) => {
	const [loading, setLoading] = useState(false);
	const [updateModalVisible, setUpdateModalVisible] = useState(false);
	const [selectedEtapeModele, setSelectedEtapeModele] = useState(null);
	const [organizing, setOrganizing] = useState(false);
	const [updatingOrder, setUpdatingOrder] = useState(false);

	const handleDelete = (idOrUid) => {
		setLoading(true);
		EtapeModeleService.getInstance()
			.remove(idOrUid)
			.then((response) => {
				Toast.success(response.message);
				setEtapeModeles(response.data);
				// setEtapeModeles((items) => items.filter((item) => item.id !== idOrUid));
			})
			.catch((error) => {
				catchError(error);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const openEditModal = (item) => {
		setSelectedEtapeModele(item);
		setUpdateModalVisible(true);
	};

	const onUpdate = (item) => {
		setEtapeModeles((etapeModeles) =>
			etapeModeles.map((u) => (u.id === item.id ? item : u))
		);
		setSelectedEtapeModele(null);
		setUpdateModalVisible(false);
	};

	const onSaveOrder = (newEtapeModeles) => {
		setUpdatingOrder(true);
		EtapeModeleService.getInstance()
			.updateOrder({
				ids: newEtapeModeles.map((item) => item.id),
				ordres: newEtapeModeles.map((_, index) => index + 1),
			})
			.then((response) => {
				Toast.success(response.message);
				setEtapeModeles(response.data);
				setOrganizing(false);
			})
			.catch((error) => {
				catchError(error);
			})
			.finally(() => {
				setUpdatingOrder(false);
			});
	};

	const handleResolu = (etapeModele, resolu) => {
		etapeModele.resolu = resolu;

		EtapeModeleService.getInstance()
			.update(etapeModele.id, etapeModele)
			.then((response) => {
				Toast.success(response.message);
				setEtapeModeles((items) =>
					items.map((item) =>
						item.id === etapeModele.id ? { ...item, resolu } : item
					)
				);
			});
	};

	const columns = [
		{
			title: "Ordre",
			dataIndex: "ordre",
			key: "ordre",
			width: 80,
		},
		{
			title: "Etape",
			dataIndex: "etape",
			key: "etape",
			width: 150,
			render: (etape) => <span>{etape?.nom}</span>,
		},

		{
			title: "Statut Résolu",
			dataIndex: "resolu",
			key: "resolu",
			width: 150,
			render: (resolu, record) => (
				<Switch
					checkedChildren={<CheckOutlined />}
					unCheckedChildren={<CloseOutlined />}
					value={resolu}
					onChange={() => handleResolu(record, !record?.resolu)}
				/>
			),
		},

		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<Dropdown
					menu={{
						items: [
							{
								key: "edit",
								label: "Modifier",
								icon: <EditFilled />,
								onClick: () => openEditModal(record),
							},
							{
								key: "delete",
								label: "Supprimer",
								icon: <DeleteFilled />,
								danger: true,
								onClick: () => {
									Modal.confirm({
										title: `Voulez-vous vraiment procéder à la suppression ?`,
										okText: "Confirmer",
										cancelText: "Annuler",
										okType: "danger",
										onOk: () => handleDelete(record.id),
									});
								},
							},
						],
					}}
				>
					<Button>
						Actions <DownOutlined />
					</Button>
				</Dropdown>
			),
			width: 120,
			fixed: "right",
		},
	];

	return (
		<>
			<Spin spinning={loading || updatingOrder}>
				{!organizing ? (
					<>
						{etapeModeles && (
							<Card>
								<Flex justify='end' gap={8}>
									<Button
										onClick={() => setOrganizing(true)}
										type='primary'
										icon={<VerticalAlignMiddleOutlined />}
									>
										Reoganiser
									</Button>
								</Flex>
							</Card>
						)}
						<Table
							rowKey={"id"}
							dataSource={etapeModeles}
							columns={columns}
							pagination={false}
						/>
					</>
				) : (
					<ReorganisableList
						initialData={etapeModeles}
						initialColumns={columns}
						pagination={false}
						onCancelOrder={() => setOrganizing(false)}
						onSaveOrder={onSaveOrder}
						updatingOrder={updatingOrder}
					/>
				)}
			</Spin>
			{selectedEtapeModele && (
				<EtapeModeleEditForm
					visible={updateModalVisible}
					etapeModeles={etapeModeles}
					etapeModele={selectedEtapeModele}
					onUpdate={onUpdate}
					onCancel={() => setUpdateModalVisible(false)}
				/>
			)}
		</>
	);
};
export default EtapeModeleList;

EtapeModeleList.propTypes = {
	etapeModeles: PropTypes.array.isRequired,
	setEtapeModeles: PropTypes.func.isRequired,
};
